import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { WebSocketAssinaturaService } from '@services/websocket-assinatura.service';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, Toast],
})
export class AppComponent {
  readonly #webSocketAssinaturaService = inject(WebSocketAssinaturaService);
  readonly #authService = inject(AuthService);

  constructor() {
    this.#webSocketAssinaturaService.conectarComWebSocket();
    this.#authService.isAuthenticated();
  }
}
